// Sol — our home system. Carries metadata only; the actual render
// data still lives in src/data/celestialData.js and is consumed by
// the legacy main.js pipeline. The catalog entry exists so the
// system list UI has a uniform record for every system the player
// can visit, including the one they start in.
//
// When the runtime swap refactor lands (Phase 2+), Sol can switch
// to the new data-driven builder, at which point the bodies field
// here becomes the source of truth and celestialData.js can shrink
// to a derived adapter.

/** @type {import('../schema.js').StarSystemData} */
export const sol = {
  id: 'sol',
  name: 'Sol',
  description: 'Home. A single G2V main-sequence star with eight planets, a dwarf planet, an asteroid belt, and the only confirmed life in the known universe.',
  galaxyPosition: { x: 0, y: 0, z: 0 },
  spectralClasses: ['G2V'],
  distanceLY: 0,
  procedural: null,
  legacy: true,

  // Sol's primary star sits at scene origin — the rest of the scene
  // is laid out around it. Legacy systems don't carry scenePosition,
  // but Sol's is the implicit (0, 0, 0).

  stars: [
    {
      id: 'sun',
      name: 'Sun',
      type: 'Star',
      spectralClass: 'G2V',
      radius: 15,
      temperature: 5778,
      realDiameter: '1,391,400 km',
      description: 'The Sun is the star at the center of our Solar System. A nearly perfect sphere of hot plasma, heated to incandescence by nuclear fusion in its core.',
      isPrimary: true,
      colors: ['#ffd93d', '#ff9500'],
      glowColor: '#ffaa00'
    }
  ],

  // Empty in the new schema — the legacy pipeline reads from
  // celestialData directly. Summary below provides the numbers for
  // the system list card.
  planets: [],
  asteroidBelt: null,
  comets: [],

  summary: {
    starCount: 1,
    planetCount: 9,
    moonCount: 'major: 14',
    notableBodies: ['Earth', 'Jupiter', 'Saturn']
  }
};
